import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import imageData from "./imageData";
import Inventory from "./Inventory";
import AllImages from "./AllImages";
import ReactGA from "react-ga4";

function App() {
  const [inventory, setInventory] = useState([]);
  const [rolledImage, setRolledImage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRarity, setSelectedRarity] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute("data-theme", savedTheme);
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }

    const savedInventory = localStorage.getItem("inventory");
    if (savedInventory) {
      setInventory(JSON.parse(savedInventory));
    }
  }, []);

  const handleClick = () => {
    ReactGA.event("rolled_image", {
      category: "Image",
      action: "Rolled an Image",
      label: "Add Random Image Button Clicked",
    });

    setIsButtonDisabled(true);

    const totalChance = imageData.reduce((acc, item) => acc + item.chance, 0);
    const randomNum = Math.random() * totalChance;

    let cumulativeChance = 0;
    let selectedImage = null;

    for (let i = 0; i < imageData.length; i++) {
      cumulativeChance += imageData[i].chance;
      if (randomNum <= cumulativeChance) {
        selectedImage = imageData[i];
        break;
      }
    }

    if (selectedImage) {
      selectedImage.rarityClass = selectedImage.rarity.toLowerCase();
      const isImageInInventory = inventory.some(
        (item) => item.name === selectedImage.name
      );

      if (!isImageInInventory) {
        const updatedInventory = [...inventory, selectedImage];
        setInventory(updatedInventory);
        localStorage.setItem("inventory", JSON.stringify(updatedInventory));
      }

      setRolledImage(selectedImage);

      ReactGA.event("rolled_image_result", {
        category: "Image",
        action: "Generated Image",
        label: selectedImage.name,
      });

      ReactGA.event("rolled_image_result_rarity", {
        category: "Image",
        action: "Generated Image Rarity",
        label: selectedImage.rarity,
      });
    }

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 1000);
  };

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
  };

  const filteredInventory = inventory.filter((item) => {
    const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesRarity = selectedRarity ? item.rarity === selectedRarity : true;
    return matchesSearch && matchesRarity;
  });

  return (
    <Router>
      <div className="container">
        <button className="theme-toggle" onClick={toggleTheme}>
          {theme === "light" ? "🌙" : "☀️"}
        </button>
        <Routes>
          <Route
            path="/"
            element={
              <div className="content">
                <h1>Hamster Gambler</h1>
                <button
                  onClick={handleClick}
                  disabled={isButtonDisabled}
                  className={isButtonDisabled ? "disabled-button" : ""}
                >
                  Add Random Image
                </button>
                {rolledImage && (
                  <div className={`rolled-image ${rolledImage.rarityClass}`}>
                    <img src={rolledImage.image} alt={rolledImage.name} />
                    <p>{rolledImage.name}</p>
                    <p>Rarity: {rolledImage.rarity}</p>
                  </div>
                )}
                <h2>Your Inventory</h2>
                <input
                  type="text"
                  placeholder="Search Inventory"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-bar"
                />
                <div className="rarity-filter">
                  <label>Filter by Rarity:</label>
                  <select
                    value={selectedRarity}
                    onChange={(e) => setSelectedRarity(e.target.value)}
                  >
                    <option value="">All Rarities</option>
                    <option value="Common">Common</option>
                    <option value="Uncommon">Uncommon</option>
                    <option value="Rare">Rare</option>
                    <option value="Epic">Epic</option>
                    <option value="Legendary">Legendary</option>
                    <option value="Mythic">Mythic</option>
                    <option value="Ultra">Ultra</option>
                  </select>
                </div>
                <Inventory inventory={filteredInventory} />
                <div className="all-images-button-container">
                  <Link to="/all-images">
                    <button className="all-images-button">View All Images</button>
                  </Link>
                </div>
              </div>
            }
          />
          <Route path="/all-images" element={<AllImages />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
